import { createFileRoute } from "@tanstack/react-router";

import { HistoryPage } from "../../../features/inventory/history-page";
import { historySearch } from "../../../features/inventory/inventory-search";

export const Route = createFileRoute("/_app/inventory/history")({
  validateSearch: historySearch,
  component: HistoryRoute,
});

function HistoryRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <HistoryPage search={search} onSearch={(next) => void navigate({ search: next })} />;
}
